export default "__VITE_ASSET__BBixAZ5f__"